import React from "react";
import { Popover} from '@headlessui/react';
import Logo from '../assets/trototLogo.png';

function Header() {

  return (
    <header className="bg-white">
    <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
      <div className="flex lg:flex-1">
        <a href="/home" className="-m-1.5 p-1.5">
          <span className="sr-only">TroTot</span>
          <img className="h-10 w-30" src={Logo} alt="" />
        </a>
      </div>
      <Popover.Group className="hidden lg:flex lg:gap-x-12">
        <a href="/home" className="text-sm font-semibold leading-6 text-gray-900">
          Trang chủ
        </a>
        <a href="/createpost" className="text-sm font-semibold leading-6 text-gray-900">
          Đăng bài
        </a>
        <a href="/service" className="text-sm font-semibold leading-6 text-gray-900">
          Nâng cấp
        </a>
        <a href="/" className="text-sm font-semibold leading-6 text-gray-900">
          Đăng xuất
        </a>
      </Popover.Group>
    </nav> 
  </header>
  );
}

export default Header;
